export default __webpack_public_path__ + "static/media/kit-sobrevivencia.7764fc19.png";